module.exports = __webpack_public_path__ + "static/media/babel.7c83c1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/babel.png
// module id = 38
// module chunks = 0